import React from "react";
import Loader from 'react-loader-spinner';
import TextInput from '../Material-UI-Components/TextInput.js';
import Captcha from './Captcha.js';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AlertDialog from '../Material-UI-Components/Dialog.js';
 
export default class SubscribeBlog extends React.Component {

    constructor(props){
        super(props);
        this.state={
          loader: false,
          emailAddress: null,
          captcha: true,
          modalTitle:'',
          modalBody:'',
          open: false
        };
      }
      

      handleOnClick=(key, value)=>{
        this.setState({[key]:value}); 
      };

      validateEmail = (text) => {
        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ ;
          return reg.test(text);
      }; 

      subscribeBlog = ()=>{
        if(this.validateEmail(this.state["emailAddress"]))
        {
          this.setState({loader:true});
                fetch("https://www.api.pratiiti.in/public/subcribeBlog",{
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({"emailAddress":this.state["emailAddress"]})
                  })
                    .then(res => res.json())
                    .then(
                      (result) => {
                        if(result.status === "Success"){
                            this.setState({open:true, loader:false, captcha:false, modalTitle:'Success', modalBody:'Thank you for subscribing our blog.'});
                        }
                        else if(result.status === "Fail"){
                            this.setState({open:true, loader:false, captcha:false, modalTitle:'Failure', modalBody:'Already subscribed'});
                        }
                      }
                    )
        }
        else
        {
          this.setState({open:true, loader:false, captcha:false, modalTitle:'Failure', modalBody:'Email Address is not valid'});
        }
    };    

  render(){
    return (
      <>
      <div className="mainContainerContact padding20">
          <h4 style={{color:'#f7941e'}}>SUBSCRIBE TO OUR BLOG</h4>
            <Grid xs={12} md={12} sm={12}>
                <div style={{marginLeft:'-10px'}}>
                  <TextInput 
                    value={this.state["emailAddress"]} 
                    fieldConfiguration={{ "columnName":"Email Address", "fieldName":"emailAddress", "isReadOnly":false, "placeHolder":"Enter Email Address", "required": true}} 
                    onClickFunction = {this.handleOnClick}
                  />
                </div>
            </Grid>
            <Grid xs={12} md={3} sm={6}>
              <Captcha onClickFunction = {this.handleOnClick}/>
            </Grid>
            <Grid xs={12} md={12} sm={12}>                          
                    {this.state.loader === true ? 
                      <Loader type="Circles" color="#f7941e" height={30} width={30}/>
                    :
                    <Button 
                        onClick={() => this.subscribeBlog()} 
                        disabled={this.state.captcha} 
                        className={this.state.captcha ? "buttonDisabled" : ""} 
                        style={{marginTop:20, color: '#ffffff', backgroundColor: '#f7941e', fontSize: 16}}>
                        {"Subscribe by email"}
                    </Button>
                      }
            </Grid>
            </div>
        <AlertDialog
          modalTitle={this.state.modalTitle}
          modalBody={this.state.modalBody}
          open={this.state.open}
          onClickFunction = {this.handleOnClick}
        />
        </>
    );
  }
}
